import type { UseMediaQueryOptions } from './use-match-media'
import { useMediaQuery } from './use-match-media'

// TODO: inline
export function useReducedMotion(
  initialValue?: boolean,
  options?: UseMediaQueryOptions,
): boolean | undefined {
  return useMediaQuery('(prefers-reduced-motion: reduce)', initialValue, options)
}
